import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-title-settings',
  imports: [CommonModule, TranslateModule],
  template: `
    <h1>{{ 'users.user-profile.title' | translate }}</h1>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleSettingsComponent {}
